import { render, staticRenderFns } from "./PageStructureSectionNew.vue?vue&type=template&id=c56300b6&"
import script from "./PageStructureSectionNew.vue?vue&type=script&lang=ts&"
export * from "./PageStructureSectionNew.vue?vue&type=script&lang=ts&"
import style0 from "./PageStructureSectionNew.vue?vue&type=style&index=0&id=c56300b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports